import { ListItem, Typography } from '@mui/material'
import { red } from '@mui/material/colors'
import React from 'react'

interface Props {
  errorMessage: string
}

export const NoOptionsText: React.FC<Props> = ({ errorMessage }) =>
  errorMessage ? (
    <ListItem>
      <Typography color={red[500]}>{errorMessage}</Typography>
    </ListItem>
  ) : (
    <ListItem>
      <Typography>No match found</Typography>
    </ListItem>
  )
